import { FEATURE_KEYS, EffectiveAccessControl } from "../../../access-control/models/role-feature.models";
import { hasFeatureAccess } from "../../../access-control/utils/feature-access";

const VESSEL_CARD_ALLOWED_EMAILS = new Set([
  "adrian_moisa@crgl-thirdparty.com",
  "guilhem_servet@cargill.com",
  "athul_velumban@cargill.com",
  "plamen_zarifov@cargill.com",
]);

interface VesselCardTokenIdentity {
  email?: string;
  sub?: string;
}

const isVesselCardAllowedEmail = (value: string | undefined): boolean =>
  Boolean(value && VESSEL_CARD_ALLOWED_EMAILS.has(value.trim().toLowerCase()));

// Role grants extend the existing test-account override; identity checks are case-insensitive.
export const canAccessVesselCard = (
  token: VesselCardTokenIdentity | null | undefined,
  accessControl?: EffectiveAccessControl | null,
): boolean =>
  isVesselCardAllowedEmail(token?.email) ||
  isVesselCardAllowedEmail(token?.sub) ||
  hasFeatureAccess(accessControl, FEATURE_KEYS.VESSEL_CARD_ACCESS);
